import { render, staticRenderFns } from "./SnackbarsBroker.vue?vue&type=template&id=0d28f7e0&"
import script from "./SnackbarsBroker.vue?vue&type=script&lang=js&"
export * from "./SnackbarsBroker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d28f7e0')) {
      api.createRecord('0d28f7e0', component.options)
    } else {
      api.reload('0d28f7e0', component.options)
    }
    module.hot.accept("./SnackbarsBroker.vue?vue&type=template&id=0d28f7e0&", function () {
      api.rerender('0d28f7e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snackbars-broker/SnackbarsBroker.vue"
export default component.exports